import React from 'react'
import MissionIcon from './MissionIcon';
import { Trans } from '@ui/i18n/trans';

interface MissionCardInterface {
  title: string;
  desc: string;
}

export default function OurMission() {
  return (
    <div className='py-80 px-10 lg:px-80'>
      <div className='w-full flex flex-wrap gap-y-80'>
        <div className="w-full lg:w-1/2 lg:pr-80 text-center lg:text-left">
          <h2 className='text-black dark:text-white font-semibold text-5xl md:text-[56px]'>
            <Trans message="Our " />
            <span className='text-gradient-pink'><Trans message="Mission" /></span>
          </h2>
          <p className='text-[#888888] text-lg mt-8'>
            <Trans message="Explore how Candy Cloudy simplifies data storage, enhances collaboration, and prioritizes your security needs." />
          </p>
        </div>
        <div className="w-full lg:w-1/2 flex flex-col gap-80">
          <MissionCard title='Easy to Use' desc='Effortless navigation and an intuitive interface ensure that managing your data is as simple as a few clicks.' />
          <MissionCard title='Unmatched Security' desc='With 256-bit encryption and regular backups, your files are protected against threats and accidental loss.' />
          <MissionCard title='Access Anytime, Anywhere' desc='Your files are always within reach – on any device, at any time, wherever you are.' />
        </div>
      </div>
    </div>
  )
}

function MissionCard({ desc, title }: MissionCardInterface) {
  return (
    <div className='flex items-start gap-32'>
      <div className='bg-[#EC008C1A] w-80 min-w-80 h-80 rounded-full flex items-center justify-center'><MissionIcon /></div>
      <div>
        <h3 className='text-[#333333] dark:text-gray-300 text-2xl font-semibold mb-16'><Trans message={title}/></h3>
        <p className='text-[#888888] font-light'><Trans message={desc}/></p>
      </div>
    </div>
  )
}